var r = /* @__PURE__ */ ((e) => (e.Base = "iress-u-card", e.Padding = "iress--padding", e.Clickable = "iress--clickable", e.Selected = "iress--selected", e.Stretch = "iress--stretch", e))(r || {}), i = /* @__PURE__ */ ((e) => (e.Prepend = "iress-u-card__prepend", e.Heading = "iress-u-card__heading", e.TopRight = "iress-u-card__top-right", e.Media = "iress-u-card__media", e.Children = "iress-u-card__body", e.Footer = "iress-u-card__footer", e))(i || {});
export {
  r as CardCssClass,
  i as CardSlotClass
};
